<template>
  <div>
    <HeaderCreditor header="รายละเอียด" :img_header="header_image" link_back="creditor/report"/>
    <PuList/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/report.png'
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor.vue";
import PuList from "@/components/admin/creditor/pulist/PuList.vue";
export default {
  name: "PuMain",
  components: {
    PuList,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
